import { genericToolTip } from '@y42/gojs';
import { Binding, GraphObject, Margin, Panel, Picture, Size, TextBlock } from 'gojs';
import { OrchestrationNodeBindings, OrchestrationUINode } from '../../../../models/orchestration-diagram.model';
import { orchestrationDiagramConfig } from '../../../config/orchestration-diagram.config';
import {
  dsLogoBinding,
  dsTextBinding,
  dsTextColorBinding,
  subEntryLogoBinding,
  tableTextBinding,
} from '../utils/bindings';

const $ = GraphObject.make;

export const DetailsPanel = () => $(Panel, Panel.Vertical, EntryPanel(), subEntryPanel());

const EntryPanel = () =>
  $(
    Panel,
    Panel.Horizontal,
    {
      padding: new Margin(0, 5),
      height: 20,
    },
    dsImage(),
    dsTextBlock(),
  );

const subEntryPanel = () =>
  $(
    Panel,
    Panel.Horizontal,
    {
      padding: new Margin(0, 5),
      height: 20,
    },
    subEntryLogo(),
    tableTextBlock(),
  );

const dsImage = () =>
  $(
    Picture,
    {
      desiredSize: new Size(16, 16),
      imageStretch: GraphObject.Uniform,
      margin: new Margin(0, 5),
      toolTip: deletedSourceTooltip(),
    },
    dsLogoBinding(),
  );

const dsTextBlock = () =>
  $(
    TextBlock,
    {
      width: 200,
      margin: new Margin(0, 5),
      stroke: orchestrationDiagramConfig.colors.primary,
      font: `${orchestrationDiagramConfig.font.style} ${orchestrationDiagramConfig.font.size.regular} ${orchestrationDiagramConfig.font.family}`,
      overflow: TextBlock.OverflowEllipsis,
    },
    dsTextBinding(),
    dsTextColorBinding(),
  );

const subEntryLogo = () =>
  $(
    Picture,
    {
      desiredSize: new Size(16, 16),
      imageStretch: GraphObject.Uniform,
      margin: new Margin(0, 5),
    },
    subEntryLogoBinding(),
  );

const tableTextBlock = () =>
  $(
    TextBlock,
    {
      width: 200,
      margin: new Margin(0, 5),
      stroke: orchestrationDiagramConfig.colors.primary,
      font: `${orchestrationDiagramConfig.font.style} ${orchestrationDiagramConfig.font.size.big} ${orchestrationDiagramConfig.font.family}`,
      overflow: TextBlock.OverflowEllipsis,
    },
    tableTextBinding(),
    dsTextColorBinding(),
  );

const deletedSourceTooltip = () =>
  genericToolTip(
    {
      colors: {
        fill: orchestrationDiagramConfig.tooltip.colors.fill,
        stroke: orchestrationDiagramConfig.tooltip.colors.stroke,
      },
    },
    [
      new Binding('text', '', (node: OrchestrationUINode) => {
        return `"${node.path}" is deleted.`;
      }),
    ],
    [new Binding('visible', OrchestrationNodeBindings.DeletedSource)],
  );
